$(document).ready(function () {
    var STORAGE_KEY = 'recently-viewed-products';
    var MAX_PRODUCTS = 10;
    var SECTION_ID = 'recently-viewed-card';

    var section = document.querySelector('.recently-viewed-products[data-product-handle]');
    if (!section) return;

    var currentHandle = section.dataset.productHandle;
    var title = section.dataset.title || 'Recently Viewed';

    var stored = [];
    try {
        stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
        stored = [];
    }

    if (currentHandle) {
        stored = stored.filter(function (h) { return h !== currentHandle; });
        stored.unshift(currentHandle);
        if (stored.length > MAX_PRODUCTS) {
            stored = stored.slice(0, MAX_PRODUCTS);
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    }

    var toShow = stored.filter(function (h) { return h !== currentHandle; });

    if (toShow.length === 0) return;

    var fetches = toShow.map(function (handle) {
        return fetch('/products/' + handle + '?section_id=' + SECTION_ID)
            .then(function (response) {
                if (!response.ok) return null;
                return response.text();
            })
            .then(function (html) {
                if (!html) return null;
                var temp = document.createElement('div');
                temp.innerHTML = html;
                var card = temp.querySelector('.product-preview, .product-card');
                return card ? card.outerHTML : null;
            })
            .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (cards) {
        var validCards = cards.filter(function (c) { return c !== null; });

        if (validCards.length === 0) return;

        var isRtl = document.body.classList.contains('rtl');
        var dir = isRtl ? 'rtl' : 'ltr';

        section.innerHTML =
            '<div class="container">' +
                '<h2 class="mb_20">' + title + '</h2>' +
                '<div class="js-recently-viewed" dir="' + dir + '">' +
                    validCards.join('') +
                '</div>' +
            '</div>';

        $(section).find('.js-recently-viewed').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            rtl: isRtl,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            }]
        });
    });
})
